import { t } from '@web/i18n';
import { Button, Input } from '@web/ui/core';
import type { DestinationForm } from './premises_form';
import { PremisesCheck, PremisesField } from './premises_field';

interface PremisesDestinationRowProps {
  index: number;
  value: DestinationForm;
  canManage: boolean;
  canRemove: boolean;
  onChange: (next: Partial<DestinationForm>) => void;
  onRemove: () => void;
}

export function PremisesDestinationRow({
  index,
  value,
  canManage,
  canRemove,
  onChange,
  onRemove,
}: Readonly<PremisesDestinationRowProps>): React.JSX.Element {
  const iataId = `premises-iata-${String(index)}`;
  const idealId = `premises-ideal-${String(index)}`;
  const toleratedId = `premises-tolerated-${String(index)}`;
  return (
    <div className="flex flex-wrap items-end gap-2">
      <PremisesField id={iataId} label={t('mice.premises.iata')}>
        <Input
          id={iataId}
          value={value.iata}
          disabled={!canManage}
          maxLength={3}
          onChange={(e) => {
            onChange({ iata: e.target.value.toUpperCase() });
          }}
        />
      </PremisesField>
      <PremisesField id={idealId} label={t('mice.premises.arrivalIdeal')}>
        <Input
          id={idealId}
          type="time"
          value={value.arrivalIdeal}
          disabled={!canManage}
          onChange={(e) => {
            onChange({ arrivalIdeal: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesField id={toleratedId} label={t('mice.premises.arrivalTolerated')}>
        <Input
          id={toleratedId}
          type="time"
          value={value.arrivalTolerated}
          disabled={!canManage}
          onChange={(e) => {
            onChange({ arrivalTolerated: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesCheck
        label={t('mice.premises.lastResort')}
        checked={value.lastResort}
        disabled={!canManage}
        onChange={(on) => {
          onChange({ lastResort: on });
        }}
      />
      {canManage && canRemove ? (
        <Button
          size="sm"
          variant="ghost"
          aria-label={t('mice.premises.removeDestination', { iata: value.iata })}
          onClick={onRemove}
        >
          ×
        </Button>
      ) : null}
    </div>
  );
}
